import { Component, inject, Input, OnInit } from '@angular/core';
import { UuidService } from 'src/app/core/services/uuid.service';

@Component({
    selector: 'app-sub-navigation',
    templateUrl: './sub-navigation.component.html',
    styleUrls: ['./sub-navigation.component.scss'],
    standalone: false
})
export class SubNavigationComponent implements OnInit {

  @Input() header: string;
  @Input() links: any[];
  @Input() type: string = 'regular';

  uuid = inject(UuidService);

  show: boolean;
  contentMargin = 240;

  constructor() { }

  ngOnInit(): void {

    this.links.forEach(link => {
      link.uuid = this.uuid.generateUUID();
    });

    let local = JSON.parse(localStorage.getItem('showHideMenu'));
    if (local != null) {
      this.show = local;
    }
    else {
      this.show = true;
      this.setLocalStorage();
    }
    this.setContentMargin();
  }

  toggle() {
    this.show = !this.show;
    this.setContentMargin();
    this.setLocalStorage();
  }
  
  setLocalStorage() {
    localStorage.setItem('showHideMenu', JSON.stringify(this.show));
  }
  
  setContentMargin() {
    this.contentMargin = this.show ? 240 : 70;
  }
}